export const config_data = {
  data_source: "../src/data/stocks_data",
  valueVariable: "Ret2Week",
  // spreadsheetID: "1BdTU1_wzZe3t5WNHqW4EoHdltnKD9rUb2WMRM0S4Nac",
  spreadsheetID: "1XXG08DG-Yj4qTWsyyq1acLQZUksW_uFKN_bj51nHopU",
  axisTopLegend: "Two Week Returns %",
  bottomTopLegend: "Two Week Returns %",
  source: "market_chameleon",
  columns: [
    { used_column_name: "Symbol", orig_column_name: "Symbol", type: "string" },
    { used_column_name: "Name", orig_column_name: "Name", type: "string" },
    {
      used_column_name: "Market Cap",
      orig_column_name: "Symbol",
      type: "percent"
    },
    {
      used_column_name: "% From 50MA",
      orig_column_name: "Symbol",
      type: "percent"
    },
    {
      used_column_name: "% From 250MA",
      orig_column_name: "Symbol",
      type: "percent"
    },
    { used_column_name: "2 Week", orig_column_name: "Symbol", type: "percent" },
    {
      used_column_name: "3 Month",
      orig_column_name: "Symbol",
      type: "percent"
    },
    {
      used_column_name: "6 Month",
      orig_column_name: "Symbol",
      type: "percent"
    },
    { used_column_name: "1 Year", orig_column_name: "Symbol", type: "percent" },
    { used_column_name: "Sector", orig_column_name: "Symbol", type: "sector" },
    { used_column_name: "id", orig_column_name: "Symbol", type: "string" }
  ]
};
